import React, { createContext } from 'react'

import { serverSideQuery, useQuery } from '@/api'
import { PRODUCTIONS_TOTALS_ENDPOINT } from '@/constants'
import {
    ProductionTotalsContextType,
    ProductionTotalsParams,
    ProductionTotalsProviderProps,
    ProductionTotalsResponse,
} from '@/context/productions-total/types'

export const defaultContextValue: ProductionTotalsContextType = {
    state: {
        data: {
            totalProductions: 0,
            categoryTotals: {},
            subCategoryTotals: {},
        },
    },
    fetching: true,
}

const ProductionTotalsContext = createContext<ProductionTotalsContextType>(defaultContextValue)
const { Provider } = ProductionTotalsContext

export const ProductionTotalsProvider: React.FC<ProductionTotalsProviderProps> = ({
    children,
    initialParams,
    initialProps,
}) => {
    const { fetching, data, error } = useQuery<ProductionTotalsResponse>({
        endpoint: PRODUCTIONS_TOTALS_ENDPOINT,
        params: initialParams,
        initialFetchDisabled: !!initialProps?.data,
        initialData: initialProps?.data,
    })

    const contextValue: ProductionTotalsContextType = {
        state: { data, fetching, error },
        fetching,
        error,
    }

    return <Provider value={contextValue}>{children}</Provider>
}

export const serverSideRead = async (params: ProductionTotalsParams): Promise<ProductionTotalsResponse> => {
    const queryInstance = serverSideQuery<ProductionTotalsResponse>(PRODUCTIONS_TOTALS_ENDPOINT)
    const totalsResponse: ProductionTotalsResponse = await queryInstance(params)

    return totalsResponse
}

export default ProductionTotalsContext
